export const methods = {
  async reload() {
    this.loading = true

    this.violationID = this.$route.params.id || 0

    this.loading = false
  }
}
